import sm from "./structureMethods-helper";

export default {
  // 신규 예
  order_list_new_filter_data: [
    {
      title: '신청 일시',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '파트너 확인 여부',
      type: 'radiobutton',
      key: 'is_read',
      options:[
        {label: '전체', value:''},
        {label: '확인', value:true},
        {label: '미확인', value:false},
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_list_new_table_data: sm.tableData([
    ['id', '예약번호', 100],
    ['created_time', '신청일시', 120],
    ['name', '예약자명', 100],
    ['partner', '파트너', 120],
    ['is_read', '파트너 확인 여부', 120],
    ['product', '상품', 100],
    ['ordered_count', '수량', 100],
    ['resv_date', '이용 일정', 130],
    ['total_price', '금액', 100],
    ['pay_status_kor', '결제 상태', 100],
    ['pay_type_kor', '결제 수단', 100],
    ['order_status_kor', '이용 상태', 100],
    ['modify_delete', '예약 확정/취소', 150],
  ]),
  // 전체 예약
  order_list_all_filter_data: [
    {
      title: '신청 일시',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '파트너 확인 여부',
      type: 'radiobutton',
      key: 'is_read',
      options:[
        {label: '전체', value:''},
        {label: '확인', value:true},
        {label: '미확인', value:false},
      ]
    },
    {
      title: '결제 상태',
      type: 'checkbox',
      key: 'pay_status_list',
      value: [100,102,103],
      options: [
        {label: '미결제', value: 100},
        {label: '결제완료', value: 102},
        {label: '환불완료', value: 103}
      ]
    },
    {
      title: '이용 상태',
      type: 'checkbox',
      key: 'status_list',
      value: [100,200,300,400,401,402,500],
      options: [
        {label: '승인 대기', value: 100},
        {label: '예약 확정', value: 200},
        {label: '이용 완료', value: 300},
        {label: '취소 요청(예약자 취소)', value: 400},
        {label: '취소 완료(예약자 취소)', value: 401},
        {label: '취소 완료(관리자 취소)', value: 402},
        {label: '노쇼', value: 500}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_list_all_table_data: sm.tableData([
    ['id', '예약번호', 100],
    ['created_time', '신청일시', 120],
    ['name', '예약자명', 100],
    ['partner', '파트너', 120],
    ['is_read', '파트너 확인 여부', 120],
    ['product', '상품', 100],
    ['ordered_count', '수량', 100],
    ['resv_date', '이용 일정', 130],
    ['total_price', '금액', 100],
    ['pay_status_kor', '결제 상태', 100],
    ['pay_type_kor', '결제 수단', 100],
    ['order_status_kor', '이용 상태', 100],
    ['modify_delete', '예약 확정/취소', 150],
  ]),
}
